import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKodemCli = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 54,
	height: 54,
	viewBox: "0 0 54 54",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M6.56966 53.9948C2.94733 53.9948 0 51.0475 0 47.4252V6.56966C0 2.94733 2.94733 0 6.56966 0H47.4303C51.0527 0 54 2.94733 54 6.56966V47.4303C54 51.0527 51.0527 54 47.4303 54H6.56966V53.9948ZM6.56966 4.96202C5.6834 4.96202 4.96718 5.6834 4.96718 6.5645V47.4252C4.96718 48.3115 5.68855 49.0277 6.56966 49.0277H47.4303C48.3166 49.0277 49.0328 48.3063 49.0328 47.4252V6.56966C49.0328 5.6834 48.3115 4.96718 47.4303 4.96718H6.56966V4.96202ZM24.9544 40.7164C23.5838 40.7164 22.4708 39.6034 22.4708 38.2328C22.4708 36.8622 23.5838 35.7492 24.9544 35.7492H42.3189C43.6895 35.7492 44.8025 36.8622 44.8025 38.2328C44.8025 39.6034 43.6895 40.7164 42.3189 40.7164H24.9544ZM11.6811 40.5103C10.9855 40.5103 10.3105 40.2115 9.8416 39.691C8.92443 38.676 9.00687 37.1044 10.0271 36.1872L20.2294 26.9948L10.0168 17.8025C9.52214 17.3594 9.23359 16.7513 9.19752 16.0866C9.16145 15.4219 9.38817 14.7882 9.8313 14.2935C10.3002 13.7731 10.9752 13.4742 11.676 13.4742C12.2891 13.4742 12.8765 13.701 13.3351 14.108L25.5933 25.1399C26.1189 25.6139 26.4177 26.2889 26.4177 26.9897C26.4177 27.6905 26.1189 28.3603 25.5985 28.8343L13.3403 39.8662C12.8868 40.2784 12.2994 40.5052 11.6811 40.5052V40.5103Z",
			fill: "url(#paint0_linear_113679_661)"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_113679_661",
			x1: 6.5,
			y1: 13.5,
			x2: 47,
			y2: 37.5,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .100856,
				stopColor: "#FF6868"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FEB45E"
			})]
		}) })
	]
});
const ForwardRef = forwardRef(SvgKodemCli);
export { ForwardRef as ReactComponent };
